import marked from "marked";

// @see https://marked.js.org/using_advanced
const options = {
	gfm: true,
	breaks: true,
	smartLists: true,
	xhtml: true,
};

// @see https://marked.js.org/using_pro#renderer
const renderer = {
	heading( text /* , level*/ ) {
		return text;
	},
};

marked.setOptions( options );
marked.use( { renderer, } );

export default marked;
